var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"relative"}},[_c('gmap-map',{ref:"map",staticStyle:{"height":"100%","width":"100%"},attrs:{"center":_vm.mapCenter,"zoom":_vm.zoom,"options":{
      zoomControl: true,
      fullscreenControl: false,
      zoomControlOptions: {
        position: 3
      }
    }},on:{"center_changed":_vm.updateCenter}}),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-marker"},[_c('div',{staticClass:"center-top-box"},[_c('i',{staticClass:"fas fa-map-marker-alt"})]),_c('div',{staticClass:"center-bottom-box"})])}]

export { render, staticRenderFns }